import LightGallery from "lightgallery/react";
import lgZoom from "lightgallery/plugins/zoom";
import lgThumbnail from "lightgallery/plugins/thumbnail";

import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-video.css";
import "lightgallery/css/lg-thumbnail.css";
import { ReactNode } from "react";
import config from "@shared/config/client";

export interface Props {
  className?: string;
  children: ReactNode;
}

const Gallery = ({ children, className, ...props }: Props) => {
  return (
    <LightGallery
      plugins={[lgZoom, lgThumbnail]}
      mode="lg-fade"
      elementClassNames={className}
      licenseKey={config.lightGallery.license}
      {...props}
    >
      {children}
    </LightGallery>
  );
};

export default Gallery;
